import React, { useCallback, type MouseEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { LeftFooterButton } from '../../../common/ui/left-footer-button/index.tsx';
import messages from './messages.tsx';

type Props = {
	onRestoreDefaults?: () => void;
};

export const RestoreDefaultsButton = ({ onRestoreDefaults }: Props) => {
	const { formatMessage } = useIntl();

	const handleRestoreDefaults = useCallback(
		(mouseEvent: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
			fireUIAnalytics(analyticsEvent, 'filterSearchRestoreDefaults', {
				// If number of clicks is 0, button was actioned using the keyboard
				keyboard: mouseEvent.detail === 0,
			});

			onRestoreDefaults && onRestoreDefaults();
		},
		[onRestoreDefaults],
	);

	const message = formatMessage(messages.restoreDefaultsButtonText);

	return (
		<LeftFooterButton
			message={message}
			onClick={handleRestoreDefaults}
			appearance="subtle-link"
			testId="jql-builder-basic-picker.ui.async-select.restore-defaults-button"
			hasTooltip
		/>
	);
};

export default RestoreDefaultsButton;
